import { render, staticRenderFns } from "./StaffEditModal.vue?vue&type=template&id=4a1088f1"
import script from "./StaffEditModal.vue?vue&type=script&lang=ts"
export * from "./StaffEditModal.vue?vue&type=script&lang=ts"
import style0 from "./StaffEditModal.vue?vue&type=style&index=0&id=4a1088f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports